import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class Caregiver extends DynamicFieldsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      schools: [],
      learnerIds: [],
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
